import agendaApiConfig from "../agenda/agendaApiConfig";

const baseUrl = process.env.REACT_APP_API_BASE;

const ConfiguracionService = {
  async getParametrosIniciales() {
    const { data } = await agendaApiConfig.get("/agenda-parametro/inicio", {
      baseURL: baseUrl,
      headers: {
        "X-Origin": process.env.REACT_APP_HEADER,
      },
    });

    return data.data;
  },
};

export default ConfiguracionService;
